/**
 * Internal "showcase mode" unlock.
 *
 * Gate philosophy: unlock ONCE from a query param (`?designShowcase`)
 * and persist the flag, because the login flow redirects onto the real
 * domain and drops the query string. Customers never pass the param →
 * never unlock → always render the default portal.
 *
 * Consumed by navigation (Billing row), DashboardView and AiChatWidget
 * to surface internal-only surfaces.
 */

const UNLOCK_KEY = "rook-design-showcase-unlocked";
const UNLOCK_PARAM = "designShowcase";

/**
 * Unlocked once `?designShowcase` is seen, then sticky on this browser
 * (survives the login→domain redirect that drops the query string).
 */
export const isDesignShowcaseUnlocked = (): boolean => {
  const hasParam = new URLSearchParams(
    globalThis.location?.search ?? "",
  ).has(UNLOCK_PARAM);
  if (hasParam) {
    localStorage.setItem(UNLOCK_KEY, "1");
    return true;
  }
  return localStorage.getItem(UNLOCK_KEY) === "1";
};
